import apiClient from "../apiClient";
import { ACTIVITIES_ENDPOINTS } from "../endpoints/activities";
import {
  buildActivityFilterPayload,
  compactActivityListPayload,
} from "@/utils/activityListing";

export const fetchActivityHome = async (params) => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.home, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching activity home:", error);
    throw error;
  }
};

export const searchActivities = async (payload = {}) => {
  try {
    const response = await apiClient.post(ACTIVITIES_ENDPOINTS.search, payload);
    return response.data;
  } catch (error) {
    console.error("Error searching activities:", error);
    throw error;
  }
};

export const fetchActivitiesList = async (payload = {}) => {
  try {
    const response = await apiClient.post(
      ACTIVITIES_ENDPOINTS.list,
      compactActivityListPayload(payload)
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching activities list:", error);
    throw error;
  }
};

export const fetchActivityFilters = async (query = {}) => {
  try {
    const response = await apiClient.post(
      ACTIVITIES_ENDPOINTS.activityFilters,
      buildActivityFilterPayload(query)
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching activity filters:", error);
    throw error;
  }
};

export const searchActivity = async (prefix = "") => {
  try {
    const query = String(prefix || "").trim();
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.searchActivity, {
      params: query ? { prefix: query } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error("Error searching activities:", error);
    throw error;
  }
};

export const fetchActivities = fetchActivitiesList;

export const fetchActivityById = async (id) => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.byId, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching activity:", error);
    throw error;
  }
};

export const fetchActivityDetailsBySlug = async (slug) => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.detailsBySlug, {
      params: { slug },
    });
    console.log(response);
    
    return response.data;
  } catch (error) {
    console.error("Error fetching activity details by slug:", error);
    throw error;
  }
};

export const fetchActivityCategories = async (params) => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.categories, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching activity categories:", error);
    throw error;
  }
};

export const fetchCitySpecificExperiences = async (params) => {
  try {
    const response = await apiClient.get(
      ACTIVITIES_ENDPOINTS.citySpecificExperiences,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching city specific experiences:", error);
    throw error;
  }
};

/** @deprecated use fetchCitySpecificExperiences */
export const fetchCityExperiences = fetchCitySpecificExperiences;

export const fetchChooseActivities = async (params) => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.chooseActivities, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching choose activities:", error);
    throw error;
  }
};

export const fetchFeaturedActivities = async (params) => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.featuredActivities, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching featured activities:", error);
    throw error;
  }
};

export const fetchSimilarActivities = async (activityId) => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.similarActivities, {
      params: { ActivityId: activityId },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching similar activities:", error);
    throw error;
  }
};

export const fetchActivityHomePageHeading = async () => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.homePageHeading);
    return response.data;
  } catch (error) {
    console.error("Error fetching activity home page heading:", error);
    throw error;
  }
};

export const fetchActivityHomePageAdvertisement = async () => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.homePageAdvertisement);
    return response.data;
  } catch (error) {
    console.error("Error fetching activity home page advertisement:", error);
    throw error;
  }
};

export const fetchActivityListPageHeading = async () => {
  try {
    const response = await apiClient.get(ACTIVITIES_ENDPOINTS.listPageHeading);
    return response.data;
  } catch (error) {
    console.error("Error fetching activity list page heading:", error);
    throw error;
  }
};
